var riot = require("riot");

riot.tag2('ahv-misc-display', '<div class="ahv-display" id="ahv-misc-display" show="{misc.length > 0}"> <div class="ahv-display-header"> Forhold som kan påvirke verdi </div> <table class="table table-bordered table-condensed table-hover"> <thead> <tr> <th>Forhold</th> <th>Beskrivelse</th> <th>Ref.</th> </tr> </thead> <tbody> <tr each="{m in misc}"> <td>{m.type}</td> <td>{m.text}</td> <td> <a class="glyphicon glyphicon-info-sign" id="ahv-misc-reference" href="{m.href}" target="_blank" show="{m.href}"></a> </td> </tr> </tbody> </table> <div class="ahv-display-footer">&nbsp;</div> </div>', '', '', function(opts) {
    require("./MiscDisplayMapper").init(this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/miscDisplay/ahv-misc-display.tag
 ** module id = 77
 ** module chunks = 0
 **/